import * as React from "react";
import useProductName from "brand-customization/useProductName";
import Modal from "components/bootstrap/Modal";
import DisclaimerModalContent from "security-app/components/Investigations/AIReport/DisclaimerModalContent";
import AIReportModalContent from "security-app/components/Investigations/AIReport/AIReportModalContent";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import useAITermsAcceptance from "ai/hooks/useAITermsAcceptance";
import Spinner from "components/common/Spinner";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import Alert from "components/bootstrap/Alert";
import Button from "components/bootstrap/Button";
import ModalButtonToolbar from "components/common/ModalButtonToolbar";
const telemetryEvents = {
  cancel: TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.TERMS_AND_CONDITIONS_CANCELED,
  consent: TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.TERMS_AND_CONDITIONS_CONSENT
};
const TermsAcceptanceError = ({ error, onCancel }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement("h3", null, "Error")), /* @__PURE__ */ React.createElement(Modal.Body, null, "The following error occurred while fetching the Terms for AI functionality. Please check general connectivity between your ", productName, " server and the AI service and/or your ", productName, " server logs;", /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, error)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Close"))));
};
const AIReportModal = ({ onCancel, investigation }) => {
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  const {
    data: { accepted, error },
    isLoading: loadingAcceptance,
    refetch
  } = useAITermsAcceptance();
  const onConsent = () => {
    refetch();
  };
  return loadingAcceptance ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(Modal, { show: isAIReportFeatureEnabled, onHide: onCancel, bsSize: "large" }, error ? /* @__PURE__ */ React.createElement(TermsAcceptanceError, { error, onCancel }) : accepted ? /* @__PURE__ */ React.createElement(AIReportModalContent, { onClose: onCancel, investigation }) : /* @__PURE__ */ React.createElement(DisclaimerModalContent, { onClose: onCancel, onConsent, telemetryEvents }));
};
export default AIReportModal;
